import React__default from 'react';
import { getRenderLeaf } from '../../../../core/rendering/getRenderLeaf.mjs';
import { getLeafDeserializer } from '../../../../core/serialization/deserialize/utilities/getLeafDeserializer.mjs';
import { getHotkeyHandler } from '../../../../core/utilities/handlers/hotkeys/getHotkeyHandler.mjs';
import { getToggleMarkHotkey } from '../../../../core/utilities/handlers/hotkeys/getToggleMarkHotkey.mjs';
import { hasMark } from '../../../../core/utilities/nodes/marks/hasMark.mjs';

const Type = 'bold';
const hotkey = 'Ctrl+B';
const BoldPlugin = options => ({
  type: Type,
  hotkey,
  renderLeaf: getRenderLeaf({
    type: Type,
    rootProps: {},
    component: Bold
  }),
  serialize: {
    leaf({
      children,
      leaf
    }) {
      if (hasMark(leaf, Type)) {
        return `<strong>${children}</strong>`;
      }
      return children;
    }
  },
  deserialize: {
    leaf: getLeafDeserializer({
      type: Type,
      rules: [{
        nodeNames: ['STRONG', 'B'],
        // Pasted fragments from Google Docs are wrapped in `<b style="font-weight: normal">`
        style: style => style.fontWeight !== 'normal'
      }, {
        nodeNames: ['SPAN'],
        style: style => style.fontWeight.includes('bold') || parseInt(style.fontWeight, 10) >= 600
      }]
    })
  },
  onKeyDown: options !== null && options !== void 0 && options.onHotkey ? getHotkeyHandler(hotkey, options.onHotkey) : getToggleMarkHotkey({
    type: Type,
    hotkey
  })
});
function Bold({
  attributes,
  children
}) {
  return /*#__PURE__*/React__default.createElement("strong", attributes, children);
}

export { BoldPlugin, Type, hotkey };
